import { Language } from '../enum';
import { UnitPageLesson } from './UnitPageLesson';

export interface UnitDescriptions {
  [key: string]: string;
}

export const getCurrentLessonPosition = (lessons: UnitPageLesson[]): number => {
  return lessons.findIndex((lesson) => lesson.status === 'in_progress');
};

export const getUnitDescription = (descriptions: UnitDescriptions, ln?: string) => {
  switch (ln) {
    case Language.es:
      return descriptions.es;
    case Language.pt:
      return descriptions.pt;
    case Language.en:
    default:
      return null; // the english unit.description is equal to unit.name
  }
};
